import { minutesToSeconds } from './seconds';
export function minutesToDays(minutes) {
  return minutes / 1440;
}
export function minutesToHours(minutes) {
  return minutes / 60;
}
export function convertMinutes(minutes, toMetric) {
  switch (toMetric) {
    case 'seconds':
      return minutesToSeconds(minutes);

    case 'minutes':
      return minutes;

    case 'hours':
      return minutesToHours(minutes);

    case 'days':
      return minutesToDays(minutes);
  }
}
export function convertToMinutes(value, fromMetric) {
  switch (fromMetric) {
    case 'seconds':
      return value / 60;

    case 'minutes':
      return value;

    case 'hours':
      return value * 60;

    case 'days':
      return value * 1440;
  }
}